import * as THREE from "three";
import {
  EffectComposer,
  RenderPass,
  EffectPass,
  BloomEffect,
  KernelSize,
  BlendFunction,
} from "postprocessing";

/**
 * Selective bloom. Threshold-gated so only flows and node cores bloom —
 * the landmasses stay matte. This is the difference between "fintech" and
 * "EDM visualizer."
 */
export function buildComposer(
  renderer: THREE.WebGLRenderer,
  scene: THREE.Scene,
  camera: THREE.Camera,
): EffectComposer {
  const composer = new EffectComposer(renderer, {
    multisampling: Math.min(4, renderer.capabilities.maxSamples),
  });

  composer.addPass(new RenderPass(scene, camera));

  const bloom = new BloomEffect({
    blendFunction: BlendFunction.ADD,
    kernelSize: KernelSize.LARGE,
    luminanceThreshold: 0.62,
    luminanceSmoothing: 0.2,
    intensity: 1.15,
    mipmapBlur: true,
  });

  composer.addPass(new EffectPass(camera, bloom));
  return composer;
}
